import { BaseModelFactory } from '../../Core/BaseModelFactory';
import { Model } from '../../Core/Model';
import { ModelV5 } from './Model';
export function registerModel(id) {
    return function (target) {
        applyMixins(target, Model);
        applyMixins(target, ModelV5);
        BaseModelFactory.registrateType(id, target);
        return target;
    };
}
export function applyMixins(derivedClass, baseClass) {
    Object.getOwnPropertyNames(baseClass.prototype).forEach(function (name) {
        Object.defineProperty(derivedClass.prototype, name, Object.getOwnPropertyDescriptor(baseClass.prototype, name) ||
            Object.create(null));
    });
}
